var styles = {"progressBar":"styles_progress-bar__BUmvz","unfilledArc":"styles_unfilled-arc__5CGl6","filledArc":"styles_filled-arc__4ck-m"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
